import { getParsed, SESSION_KEYS, setParsed } from '@/services/browserStorage'
import { usePathname } from 'next/navigation'
import { createContext, useContext, useEffect } from 'react'

interface HistoryContextType {
  getHistory: () => Array<string>
}

export const HistoryContext = createContext<HistoryContextType>(
  {} as HistoryContextType
)

interface HistoryProviderProps {
  children: React.ReactNode
}

export function HistoryProvider({ children }: HistoryProviderProps) {
  const pathname = usePathname()

  useEffect(() => {
    const history = getParsed<Array<string>>(
      sessionStorage,
      SESSION_KEYS.history,
      []
    )

    if (pathname === history[history.length - 1]) return

    const pathIndex = history.indexOf(pathname)

    if (pathIndex !== -1) {
      history.splice(pathIndex, 1)
    }

    history.push(pathname)

    setParsed(sessionStorage, SESSION_KEYS.history, history)
  }, [pathname])

  const getHistory = () => {
    return getParsed<Array<string>>(sessionStorage, SESSION_KEYS.history, [])
  }

  return (
    <HistoryContext.Provider value={{ getHistory }}>
      {children}
    </HistoryContext.Provider>
  )
}

export function useHistory() {
  return useContext(HistoryContext)
}
